import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import React from "react";
import { WSQueries } from "../../../query/WSQuery";
import { useQueryPlanEnrollments } from "../../../query/benefits/useQueryPlanEnrollments";
import { useGoToMyResourceDetailsHistory } from "../paths";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

type Props = {
  planType: IPlanType;
  insuranceCoverageId: string;
  isCompactView?: boolean;
};

export const MyResourceInsuranceHistory: React.FC<Props> = ({
  planType,
  isCompactView,
  insuranceCoverageId
}) => {
  const goToMyResourceDetailsHistory = useGoToMyResourceDetailsHistory();

  const qPlanEnrollments = useQueryPlanEnrollments({
    filter: {
      planType
    }
  });

  return (
    <WSQueries queries={{ qPlanEnrollments }}>
      {({ qPlanEnrollmentsData }) => {
        const enrollmentResources = qPlanEnrollmentsData.map(enrollment => ({
          resourceType: "PlanEnrollment",
          resourceId: enrollment.planEnrollmentId
        }));

        const insuranceCoverageResources = [
          {
            resourceType: "InsuranceCoverage",
            resourceId: insuranceCoverageId
          }
        ];

        const resources = [
          ...enrollmentResources,
          ...insuranceCoverageResources
        ];

        return (
          <ResourceHistory
            resources={resources}
            drillDownResourceType="PlanEnrollment"
            onViewAll={
              isCompactView
                ? () => goToMyResourceDetailsHistory(insuranceCoverageId)
                : undefined
            }
          />
        );
      }}
    </WSQueries>
  );
};
